import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number
  height?: number
  color?: Color
  className?: string
}

const WalletSvg = ({ className, width = 18, height = 18, color = colors.Primary.GreyText }: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3 4H14.4V3C14.4 2.20435 14.1155 1.44129 13.6092 0.87868C13.1028 0.316071 12.4161 0 11.7 0H2.7C1.98392 0 1.29716 0.316071 0.790812 0.87868C0.284464 1.44129 0 2.20435 0 3V15C0 15.7956 0.284464 16.5587 0.790812 17.1213C1.29716 17.6839 1.98392 18 2.7 18H15.3C16.0161 18 16.7028 17.6839 17.2092 17.1213C17.7155 16.5587 18 15.7956 18 15V7C18 6.20435 17.7155 5.44129 17.2092 4.87868C16.7028 4.31607 16.0161 4 15.3 4ZM2.7 2H11.7C11.9387 2 12.1676 2.10536 12.3364 2.29289C12.5052 2.48043 12.6 2.73478 12.6 3V4H2.7C2.46131 4 2.23239 3.89464 2.0636 3.70711C1.89482 3.51957 1.8 3.26522 1.8 3C1.8 2.73478 1.89482 2.48043 2.0636 2.29289C2.23239 2.10536 2.46131 2 2.7 2ZM16.2 12H15.3C15.0613 12 14.8324 11.8946 14.6636 11.7071C14.4948 11.5196 14.4 11.2652 14.4 11C14.4 10.7348 14.4948 10.4804 14.6636 10.2929C14.8324 10.1054 15.0613 10 15.3 10H16.2V12ZM16.2 8H15.3C14.5839 8 13.8972 8.31607 13.3908 8.87868C12.8845 9.44129 12.6 10.2044 12.6 11C12.6 11.7956 12.8845 12.5587 13.3908 13.1213C13.8972 13.6839 14.5839 14 15.3 14H16.2V15C16.2 15.2652 16.1052 15.5196 15.9364 15.7071C15.7676 15.8946 15.5387 16 15.3 16H2.7C2.46131 16 2.23239 15.8946 2.0636 15.7071C1.89482 15.5196 1.8 15.2652 1.8 15V5.83C2.08914 5.94302 2.39349 6.00051 2.7 6H15.3C15.5387 6 15.7676 6.10536 15.9364 6.29289C16.1052 6.48043 16.2 6.73478 16.2 7V8Z"
      fill={color}
    />
  </svg>
)

export default WalletSvg
